var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Layout',[_c('router-view')],1),_c('BaseNotification'),(_vm.overlay && _vm.overlay.status)?_c('BaseOverlayLoading',{attrs:{"message":_vm.overlay.message}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }